// src/App.js
import React from 'react';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { NotificationProvider } from './contexts/NotificationContext';
import Dashboard from './components/Dashboard/Dashboard';
import Login from './components/Auth/Login';
import ApprovalPending from './components/Auth/ApprovalPending';
import './App.css';

const AppContent = () => {
  const { user, profile, loading } = useAuth();

  if (loading) {
    return (
      <div className="app-loading">
        <div className="loader"></div>
        <p>SWAMED Yükleniyor...</p>
      </div>
    );
  }

  // No user logged in
  if (!user) return <Login />;

  // User is logged in but profile is still being fetched — keep loading
  if (!profile) {
    return (
      <div className="app-loading">
        <div className="loader"></div>
        <p>SWAMED Yükleniyor...</p>
      </div>
    );
  }

  // Backend profile fetch failed but user is Firebase-authenticated
  if (profile.status === 'ERROR') {
    return (
      <div className="app-loading">
        <p style={{ color: '#ef4444' }}>Profil yüklenemedi. Lütfen sayfayı yenileyin.</p>
        <button onClick={() => window.location.reload()} style={{ marginTop: '12px', padding: '8px 16px', cursor: 'pointer' }}>
          Yenile
        </button>
      </div>
    );
  }

  // User is logged in but profile is not active (PENDING or REJECTED)
  if (profile.status !== 'ACTIVE') {
    return <ApprovalPending />;
  }

  // Fully active user
  return <Dashboard />;
};

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <NotificationProvider>
          <div className="App">
            <AppContent />
          </div>
        </NotificationProvider>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;